import React, { Suspense, lazy } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

//nav components (eager)
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Landing page (eager — avoids loader flash on cold load of "/")
import Home from './pages/home/Home';

// Page modules (lazy)
const Privacy = lazy(() => import('./pages/privacy/Privacy'));
const Articles = lazy(() => import('./pages/articles/Articles'));
const Terms = lazy(() => import('./pages/terms/Terms'));
const NotFound = lazy(() => import('./pages/not-found/NotFound'));
const DeleteAccount = lazy(() => import('./pages/delete-account/DeleteAccount'));
const About = lazy(() => import('./pages/about/About'));
const DigitalSolutions = lazy(() => import('./pages/digital-solutions/DigitalSolutions'));

// loading component for suspense fallback
const Loader = () => (
  <div className="container-xxl App px-4 py-5 my-5 text-center">
    <div className='row App-logo-container' style={{alignContent: 'center'}}>
      <img src="/digital_spa_logo_192.png" className="App-logo" alt="logo" style={{height:80, width:100}}/>
      <div>loading...</div>
    </div>
  </div>
);

function App() {

  return (
    <HelmetProvider>
      <div className='App'>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="main-content">
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/terms-and-conditions" element={<Terms />} />
                <Route path="/articles" element={<Articles />} />
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="/about" element={<About />} />
                <Route path="/digital-solutions" element={<DigitalSolutions />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer/>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
